import moment = require("moment");
import {Moment} from "moment";
import * as React from "react";
import {RestDataLoader} from "../../../../dashboard/widgets/unilever/RestDataLoader";
import {Loader} from "../../../../components/Utils/loader/Loader";
import {JSONTablePageTexts} from "./CoffeeMachineDashboard";
import {TableHistoricConsumptions} from "./components/widgets/TableHistoricConsumptions";

interface WidgetProps {
    equipmentGuid: string;
    texts: JSONTablePageTexts;
    fromDate: Moment;
    toDate: Moment;
    totalCoffeeGroups: number;
    showSalesData: boolean;
}

interface WidgetState {
    tableData: any;
    currentTablePage: number;
    consumedWater: number;
    consumedCoffee: number;
    selectedGroup: number;
}

export const TABLE_PAGE_SIZE = 100;
const COFFEE_PER_CONSUMPTION = 7;

export class CoffeeMachineTablePage extends React.Component<WidgetProps, WidgetState> {

    constructor(props) {
        super(props);
        this.loadData = this.loadData.bind(this);
        this.changeSelectedGroup = this.changeSelectedGroup.bind(this);
        this.state = {
            tableData: null,
            currentTablePage: 0,
            consumedCoffee: null,
            consumedWater: null,
            selectedGroup: -1,
        };
    }

    public render() {
        let tableWidget = <Loader />;
        if (this.state.tableData != null) {
            tableWidget = (
                <TableHistoricConsumptions
                    totalTablePage={parseInt("" + (this.state.tableData.total / TABLE_PAGE_SIZE + 1), 10)}
                    currentPage={this.state.currentTablePage}
                    changePage={this.loadData}
                    texts={this.props.texts}
                    tableData={this.prepareData()}
                    consumedCoffee={this.state.consumedCoffee}
                    consumedWater={this.state.consumedWater}
                    selectedGroup={this.state.selectedGroup}
                    onGroupChange={this.changeSelectedGroup}
                    totalCoffeeGroups={this.props.totalCoffeeGroups}
                    showSalesData={this.props.showSalesData}
                />
            );
        }
        return (
            <div className="coffee-machine-table-page">
                {tableWidget}
            </div>
        );
    }

    public componentDidMount(): void {
        this.loadData(0);
    }

    public componentWillReceiveProps(nextProps: Readonly<WidgetProps>, nextContext: any): void {
        this.setState(
            {
                tableData: null,
                currentTablePage: 0,
                consumedWater: null,
                consumedCoffee: null,
            },
        );
    }

    public componentDidUpdate(
        prevProps: Readonly<WidgetProps>,
        prevState: Readonly<WidgetState>,
        snapshot?: any,
    ): void {
        if (this.state.tableData == null
            && this.state.currentTablePage === 0
            && this.state.consumedWater == null
            && this.state.consumedCoffee == null) {
            this.loadData(0);
        } else if (prevState.selectedGroup !== this.state.selectedGroup) {
            this.loadTableData(this.state.currentTablePage);
        }
    }

    private changeSelectedGroup(group) {
        if (this.state.selectedGroup !== group) {
            this.setState(
                {
                    selectedGroup: group,
                    currentTablePage: 0,
                    tableData: null,
                },
            );
            console.log("Changing group filter from " + this.state.selectedGroup + " to " + group);
        }
    }

    private loadData(tablePage?: number) {
        this.loadTableData(tablePage);
        const requestData: any = {};
        requestData.beginDate = this.props.fromDate.startOf("day").format("YYYY-MM-DDTHH:mm").toString();
        requestData.endDate = moment().endOf("day").format("YYYY-MM-DDTHH:mm").toString();
        const type: any = {};
        type.guid = "6c0c09bc-1d24-11e8-8cd2-525400c5f801";
        type.numberOfPixels = 0;
        const aggregation: any = {};
        aggregation.aggregationFunction = "SUM";
        aggregation.paramIndex = 1;
        type.aggregations = [aggregation];
        requestData.types = [type];
        RestDataLoader.postJSON(
            "filters/diagnostics",
            requestData,
            (responseData) => {
                RestDataLoader.loadData(
                    "equipment/" + this.props.equipmentGuid + "/diagnostics",
                    {
                        filterGuid: responseData.guid,
                    },
                    (diagnosticData: any) => {
                        let totalWater = null;
                        if (diagnosticData != null
                            && diagnosticData.list.length > 0
                            && diagnosticData.list[0].aggregations.length > 0
                            && diagnosticData.list[0].aggregations?.[0]?.data?.param1) {
                            totalWater = diagnosticData.list[0].aggregations?.[0]?.data?.param1 / 10;
                        }
                        this.setState({consumedWater: totalWater});
                    },
                    () => {
                        console.log("Error requesting data");
                    },
                );
            },
            () => {
                console.log("Error requesting data");
            },
        );

        RestDataLoader.loadData(
            "equipment/coffeeMachines/" + this.props.equipmentGuid + "/coffees/count",
            {
                startDate: this.props.fromDate.startOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                endDate: this.props.toDate.endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
            },
            (data: any) => {
                let count = null;
                if (data && data.count != null) {
                    count = data.count * COFFEE_PER_CONSUMPTION / 1000;
                }
                this.setState({consumedCoffee: count});
            },
            () => {
                console.log("Errore requesting data");
            },
        );
    }

    private loadTableData(tablePage?: number): void {
        let page = 0;
        if (tablePage) {
            page = tablePage;
        }
        let url = "equipment/coffeeMachines/" + this.props.equipmentGuid + "/consumptions";
        if (this.state.selectedGroup != null && this.state.selectedGroup > 0) {
            url += "?dispensingGroup=" + this.state.selectedGroup;
        }
        RestDataLoader.loadData(
            url,
            {
                startDate: this.props.fromDate.startOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                endDate: this.props.toDate.endOf("day").format("YYYY-MM-DDTHH:mm").toString(),
                offset: page * TABLE_PAGE_SIZE,
                limit: TABLE_PAGE_SIZE,
            },
            (data) => {
                this.setState({tableData: data, currentTablePage: page});
            },
            () => {
                console.log("Error requesting data");
            },
        );
    }

    private prepareData = () => {
        const cloneTableData = [];
        this.state.tableData.list.forEach((r) => {
            const tmp = {...r};
            tmp.consumptionType = (r.continueConsumption == null
                ? this.props.texts.consumptionTypeUnknown
                : (r.continueConsumption
                    ? this.props.texts.consumptionTypeContinue
                    : this.props.texts.consumptionTypePreset));
            cloneTableData.push({...tmp});
        });
        return cloneTableData;
    }

}
